import { Select, TimePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import moment from 'moment-timezone';
import './_SueItemUpdate.css';

interface Props {
    sueData: any;
    accidentTime: string | null;
    onTimeChange: (time: any) => void;
    onBlurTime: (e: any) => void;
    onDateChange: (field: string, date: Date) => void;
    onAccidentDamageParameterChange:(e: any, paramName: string) => void;
    onAccidentDamageSelectChange:(newValue: string, paramName: string) => void;
    showLessTabs: boolean;
}

const AccidentDetailsAndPlace = (props: Props) => {
    return (
        <div className='white-block white-block-fixed-height'>
            <section className=''>
                <div className='section-sue-title'>
                    פרטי המקרה/תאונה
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאריך ושעה של מקרה
                            </div>
                            <div className="value">
                                {props.accidentTime && 
                                <TimePicker
                                    variant="borderless"
                                    onChange={props.onTimeChange}
                                    onBlur={props.onBlurTime}
                                    defaultValue={dayjs(props.accidentTime, 'HH:mm')}
                                    value={dayjs(props.accidentTime, 'HH:mm')}
                                    format={'HH:mm'}
                                    // getPopupContainer={(triggerNode: HTMLElement) => triggerNode.parentNode as HTMLElement}
                                    // disabled={!props.sueData.sueAccidentAndDamageInfo}
                                    // needConfirm
                                    popupClassName='time-picker-time-list'
                                />}
                                <CompDatePicker value={props.sueData.sueAccidentAndDamageInfo ? new Date(props.sueData.sueAccidentAndDamageInfo.accidentDateTime) : null} onChange={(date: Date) => props.onDateChange('accidentDateTime', date)} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                האם הובא לידיעת משטרה?
                            </div>
                            <div className="value">
                                <Select
                                    style={{ width: '100%' }}
                                    placeholder=""
                                    value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.isPoliceNotified ? '1' : '2'}
                                    onChange={(value: string) => props.onAccidentDamageSelectChange(value, 'isPoliceNotified')}
                                    options={
                                        [
                                            {
                                                label: 'כן',
                                                value: '1'
                                            },
                                            {
                                                label: 'לא',
                                                value: '2'
                                            }
                                        ]
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                שם התחנה
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.stationName} onChange={(e: any) => props.onAccidentDamageParameterChange(e, 'stationName')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מס' יומן/תיק
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.caseNumber} onChange={(e: any) => props.onAccidentDamageParameterChange(e, 'caseNumber')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                כתובת הנכס
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.accidentAddress} onChange={(e: any) => props.onAccidentDamageParameterChange(e, 'accidentAddress')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className="parameter-row single-item">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאור נסיבות המקרה
                            </div>
                            <div className="value">
                                <textarea className='accidentDetails' onChange={(e: any) => props.onAccidentDamageParameterChange(e, 'accidentDetails')} onBlur={(e: any) => { }}
                                    value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.accidentDetails} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className={`with-top-border ${props.showLessTabs ? 'hide' : ''}`}>
                <div className='section-sue-title'>
                    נזקים
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאור הנזקים
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.insuredCarDamageDescription} onChange={(e: any) => props.onAccidentDamageParameterChange(e, 'insuredCarDamageDescription')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאור הנזקים צד ג'
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.thirdPartyCarDamageDescription} onChange={(e: any) => props.onAccidentDamageParameterChange(e, 'thirdPartyCarDamageDescription')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    )
}

export default AccidentDetailsAndPlace